import { useLayoutEffect, useRef } from "react";
import { motion } from "framer-motion";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const PageHero = ({ eyebrow, title, titleTestId, heroTestId, children }) => {
  const bgRef = useRef(null);
  const heroRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        bgRef.current,
        { backgroundColor: "#0A2647" },
        {
          backgroundColor: "#F2F8F9",
          ease: "none",
          scrollTrigger: {
            trigger: heroRef.current,
            start: "bottom 95%",
            end: "bottom 25%",
            scrub: true,
          },
        }
      );
    });
    return () => ctx.revert();
  }, []);

  return (
    <>
      <div
        ref={bgRef}
        className="fixed inset-0 -z-10"
        style={{ backgroundColor: "#0A2647" }}
        aria-hidden="true"
      />
      <section
        ref={heroRef}
        className="relative flex min-h-[92svh] flex-col items-center justify-center px-6 text-center text-white"
        data-testid={heroTestId}
      >
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="text-[11px] font-semibold uppercase tracking-[0.45em] text-[#D6EBEE]/80"
        >
          {eyebrow}
        </motion.p>
        <h1 className="mt-6 font-display text-6xl font-semibold tracking-[0.02em] sm:text-7xl md:text-8xl">
          <span className="block overflow-hidden pb-3">
            <motion.span
              initial={{ y: "112%" }}
              animate={{ y: 0 }}
              transition={{ duration: 1.1, delay: 0.25, ease: [0.22, 1, 0.36, 1] }}
              className="block"
              data-testid={titleTestId}
            >
              {title}
            </motion.span>
          </span>
        </h1>
        <motion.span
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 0.9, delay: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="mt-4 block h-[2px] w-24 origin-center bg-[#F47221]"
          aria-hidden="true"
        />
        {children}
      </section>
    </>
  );
};
